import Box from "@untitled-ui/icons-react/build/esm/Box";
import Building07 from "@untitled-ui/icons-react/build/esm/Building07";
import Speedometer04 from "@untitled-ui/icons-react/build/esm/Speedometer04";
import Tag03 from "@untitled-ui/icons-react/build/esm/Tag03";
import { ReactComponent as ShopTag } from "../assets/icons/shop-tag.svg";
import { ReactComponent as Camera } from "../assets/icons/camera-03.svg";
import { ReactComponent as FFCIcon } from "../assets/icons/ffcenter-icon.svg";
import { ReactComponent as Shop1 } from "../assets/icons/shop-1.svg";
import { ReactComponent as Shirt } from "../assets/icons/tshirt-linear.svg";
import { ReactComponent as user } from "../assets/icons/user-circle.svg";
import { ReactComponent as SalesInsight } from "../assets/icons/sales-insight.svg";
import { ReactComponent as Users } from "../assets/icons/users-03.svg";
import { ReactComponent as BuyingIntel } from "../assets/icons/buying-intel.svg";
import NanaBoCompactWhite from "../assets/images/nanaBOCompactWhite.png";
import { hasNavigationAccess } from "../utils/onboardingHelper";

const NanaBoIcon = props => <img {...props} alt="nanaBO" src={NanaBoCompactWhite} style={{ objectFit: "contain", width: 16, height: 16 }} />;

export const PRODUCTION_MENU_AVAILABILITY = Object.freeze({
    "nanaBO": false, "Dashboard": true, "Sales Intel": false, "Sales Insights": false, "Buying Intel": true, "BOimages": true,
    "Products": true, "Orders": true, "Fulfillment Centers": true, "Label Brands": true,
    "Stores and POS": true, "Retail Brands": true, "Companies": true, "Users": true, "Account": true
});

export const PRODUCTION_MENU_GROUPS = Object.freeze({
    "Buying Intel": "intel", "Sales Intel": "intel", "BOimages": "operations",
    "Products": "operations", "Orders": "operations", "Fulfillment Centers": "operations",
    "Label Brands": "operations", "Stores and POS": "operations", "Retail Brands": "operations",
    "Companies": "operations", "Users": "account", "Account": "account"
});

export const navigationBar = (path, navigations) => {
    const navigation = navigations?.navigationAccesses;

    const hasDashboardAccess = hasNavigationAccess(navigation, "dashboard", false);
    const hasSalesInsightAccess = hasNavigationAccess(navigation, "salesInsight", false);
    const hasBuyingIntelAccess = hasNavigationAccess(navigation, "buyingIntel", false);
    const hasBOImagesAccess = hasNavigationAccess(navigation, "boimages", false);
    const hasFullfillmentCentersAccess = hasNavigationAccess(navigation, "fulfillmentCenters", false);
    const hasLabelBrandsAccess = hasNavigationAccess(navigation, "labelBrands", false);

    const hasStoresAccess =
        hasNavigationAccess(navigation, "stores", false) || path.toLocaleLowerCase().startsWith("/stores");
    const hasOrdersAccess = hasNavigationAccess(navigation, "orders", false);
    const hasProductsAccess = hasNavigationAccess(navigation, "products", false);
    const hasRetailBrandsAccess = hasNavigationAccess(navigation, "retailBrands", false);
    const hasCompaniesAccess = hasNavigationAccess(navigation, "companies", false);
    const hasOrganizationAccess = hasNavigationAccess(navigation, "organization", false);
    const hasUsersAccess = hasNavigationAccess(navigation, "users", false);

    const createModeOnlyBOImages = navigation?.BOimages?.createModeOnly;
    const createModeOnlyFullfillmentCenters = navigation?.fulfillmentCenters?.createModeOnly;
    const createModeOnlyStores = navigation?.stores?.createModeOnly;
    const createModeOnlyOrders = navigation?.orders?.createModeOnly;
    const createModeOnlyProducts = navigation?.products?.createModeOnly;
    const createModeOnlyRetailBrands = navigation?.retailBrands?.createModeOnly;
    const createModeOnlyCompanies = navigation?.companies?.createModeOnly;
    const createModeOnlyOrganization = navigation?.organization?.createModeOnly;
    const createModeOnlyUsers = navigation?.users?.createModeOnly;

    return [
        {
            to: "/nanaBO", enabled: false, title: "nanaBO", iconSVG: NanaBoIcon,
            isActive: false
        },
        {
            to: "/dashboard",
            enabled: hasDashboardAccess,
            title: "Dashboard",
            iconSVG: Speedometer04,
            isActive: path.toLocaleLowerCase().startsWith("/dashboard")
        },
        {
            to: "/buying-intel",
            enabled: hasBuyingIntelAccess,
            title: "Buying Intel",
            iconSVG: BuyingIntel,
            isActive: path.toLocaleLowerCase().startsWith("/buying-intel")
        },
        {
            to: "/sales-insight",
            enabled: hasSalesInsightAccess,
            title: "Sales Intel",
            iconSVG: SalesInsight,
            isActive: path.toLocaleLowerCase().startsWith("/sales-insight")
        },
        {
            to: createModeOnlyBOImages ? "/boimages/create" : "/boimages",
            enabled: hasBOImagesAccess,
            title: "BOimages",
            iconSVG: Camera,
            isActive: path.toLocaleLowerCase().startsWith("/boimages")
        },
        {
            to: createModeOnlyProducts ? "/products/add" : "/products",
            enabled: hasProductsAccess || path.startsWith("/products"), //TODO: PATH INCLUDES PRODUCTS IN TEMPORARY SOLUTION
            title: "Products",
            iconSVG: Shirt,
            isActive: path.toLocaleLowerCase().startsWith("/products")
        },
        {
            to: createModeOnlyOrders ? "/orders/create" : "/orders", //temp
            enabled: hasOrdersAccess,
            title: "Orders",
            iconSVG: Box,
            isActive: path.toLocaleLowerCase().startsWith("/orders")
        },
        {
            to: createModeOnlyFullfillmentCenters ? "/ffcenters/management" : "/ffcenters/management", //temp
            enabled: hasFullfillmentCentersAccess,
            title: "Fulfillment Centers",
            iconSVG: FFCIcon,
            isActive: path.toLocaleLowerCase().startsWith("/ffcenters")
        },
        {
            //to: hasLabelBrandsAccess ? "/labelbrands/create" : "/labelbrands/connections",
            to: "/labelbrands/connections",
            enabled: hasLabelBrandsAccess,
            title: "Label Brands",
            iconSVG: Tag03,
            isActive: path.toLocaleLowerCase().startsWith("/labelbrands")
        },
        {
            to: createModeOnlyStores ? "/stores/create" : "/stores",
            enabled: hasStoresAccess,
            title: "Stores and POS",
            iconSVG: Shop1,
            isActive: path.toLocaleLowerCase().startsWith("/stores")
        },
        {
            to: createModeOnlyRetailBrands ? "/brands/create" : "/brands",
            enabled: hasRetailBrandsAccess,
            title: "Retail Brands",
            iconSVG: ShopTag,
            isActive: path.toLocaleLowerCase().startsWith("/brands")
        },
        {
            to: createModeOnlyCompanies ? "/companies/create" : "/companies",
            enabled: hasCompaniesAccess,
            title: "Companies",
            iconSVG: Building07,
            isActive: path.toLocaleLowerCase().startsWith("/companies")
        },
        {
            to: createModeOnlyUsers ? "/users/edit" : "/users",
            enabled: hasUsersAccess || path.startsWith("/users"),
            title: "Users",
            iconSVG: Users,
            isActive: path.toLocaleLowerCase().startsWith("/users")
        },
        {
            to: createModeOnlyOrganization ? "/account/create" : "/account",
            enabled: hasOrganizationAccess,
            title: "Account",
            iconSVG: user,
            isActive: path.toLocaleLowerCase().startsWith("/account")
        }
    ].map(item => ({ ...item, group: PRODUCTION_MENU_GROUPS[item.title], enabled: Boolean(item.enabled && PRODUCTION_MENU_AVAILABILITY[item.title]) }));
};
